import React, { useState, useEffect } from 'react';
import { i18n } from 'fishx';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { Form, Button, Table, Pagination } from '@whalecloud/fdx';
import { renderFormItems, showTotal } from '@/utils';

import styles from './index.module.less';

const DefaultPageInfo = {
  pageIndex: 1,
  pageCount: 10,
};

const SearchTablePage = props => {
  const {
    tableDataSource = [],
    total,
    formProps = {},
    tableProps = {},
    absoluteSearchFooter = false,
    form,
    onSearch,
    orgInfo,
  } = props;
  const { getFieldDecorator, validateFields, resetFields, getFieldsValue, setFieldsValue } = form;
  const { formItems } = formProps;
  const { columns, rowKey = 'key', ...otherProps } = tableProps;
  const [pageDto, setPageDto] = useState(DefaultPageInfo);

  const handleSearch = (pageInfo, searchForm = {}) => {
    const params = {
      pageDto: pageInfo || DefaultPageInfo,
      ...searchForm,
    };
    onSearch(params);
  };

  useEffect(() => {
    if (!isEmpty(orgInfo)) {
      const formInfo = getFieldsValue(); // 页面初始化时候查询数据
      handleSearch(null, formInfo); // 有些页面初始化时会带有默认表单值，需要带上
    }
  }, [orgInfo]);

  const handleFormChange = () => {
    setPageDto(DefaultPageInfo);
    validateFields().then(formInfo => {
      handleSearch(null, formInfo);
    });
  };

  const handleFormRest = () => {
    resetFields(); // 重置表单
    setFieldsValue({ orderStatus: [] }); // 重置state状态
    setPageDto(DefaultPageInfo);
    const formInfo = getFieldsValue();
    handleSearch(null, formInfo);
  };

  const handlePageChange = page => {
    const pageInfo = {
      ...pageDto,
      pageIndex: page,
    };
    setPageDto(pageInfo);
    const formInfo = getFieldsValue();
    handleSearch(pageInfo, formInfo);
  };

  return (
    <div className={`${styles.searchInfo} commonFormSearchInfo`}>
      <div>
        <Form layout="inline">
          {renderFormItems(formItems(form), getFieldDecorator)}
        </Form>
        <div className={absoluteSearchFooter ? styles.searchFooterAbs : styles.searchFooter}>
          <Button type="primary" onClick={handleFormChange}>{i18n('BTN_QUERY')}</Button>
          <Button onClick={handleFormRest}>{i18n('BTN_RESET')}</Button>
        </div>
      </div>
      <p className={styles.line} />
      <div className={styles.tableDiv}>
        <Table rowKey={rowKey} dataSource={tableDataSource} columns={columns} {...otherProps} />
        <div className={styles.pageBox}>
          <Pagination
            showQuickJumper
            showTotal={showTotal}
            total={Number(total)}
            current={pageDto.pageIndex}
            pageSize={pageDto.pageCount}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state, { modelKey }) => {
    const orgInfo = state.dxpGlobal.currentUser.orgInfo || {};
    if (!isEmpty(modelKey)) {
      return {
        tableDataSource: state[modelKey].searchTableData,
        total: state[modelKey].total,
        orgInfo,
      };
    }
    return { orgInfo };
  },
)(Form.create({ name: 'leaseline_form' })(SearchTablePage));
